import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigDebugComponent } from './config-debug.component';
import { ConfigModule } from '@spartacus/core';
import { DisplayConfig, Level } from './display.config';
import { defaultDisplayConfig } from './default-display.config';

@NgModule({
    imports: [
        CommonModule,
        ConfigModule.withConfig(defaultDisplayConfig),
        ConfigDebugComponent,
    ],
    exports: [ConfigDebugComponent],
})
export class ConfigDebugModule {}
